import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import { createSlug } from 'utils/common';
import s from './SortSelect.scss';

const SelectDropdown = ({
  options,
  onSelect,
  selectedOption,
  placeHolder = '',
  sort = false,
  isWapView = false,
  typeTwoStyle,
  selected,
  active,
  label,
  Url,
  searchOperation = false,
  handleToggleIcon,
  isMobile,
  selectIndex,
  ga4Data,
  autocomplete,
  fromRHS,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [inputData, setInputData] = useState(
    selectedOption ? selectedOption?.name : '',
  );
  const [filterOption, setFilterOption] = useState([]);
  const [isCleared, setIsCleared] = useState(false);
  const inputRef = useRef(null);
  const optionListRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleToggle = e => {
    if (sort) {
      onSelect(e);
      return;
    }
    setIsOpen(!isOpen);
    setFilterOption([...options]);
  };
  useEffect(
    () => {
      if (searchOperation && selectedOption) {
        setInputData(selectedOption?.name);
      }
    },
    [selectedOption],
  );
  const handleFocus = event => {
    event.preventDefault();

    if (inputRef?.current && !isMobile) {
      inputRef.current.select();
      if (searchOperation) {
        setInputData('');
        setIsCleared(true);
      }

      if (ga4Data) {
        analyticsWrapper('ga4', ga4Data);
      }
    }
    if (isMobile) {
      if (searchOperation) {
        setInputData('');
        setIsCleared(true);
      }
      if (ga4Data) {
        analyticsWrapper('ga4', ga4Data);
      }
    }
  };
  const notOptionsValue =
    label &&
    label !== '' &&
    label !== undefined &&
    typeof label === 'string' &&
    label.split('Select ').length > 0
      ? `${label.split('Select ')[1]} not found`
      : 'Result not found';
  useEffect(
    () => {
      if (
        searchOperation &&
        inputData !== selectedOption?.name &&
        options &&
        options.length > 0
      ) {
        const filteredOptions = options.filter(val => {
          if (inputData === '') {
            return val;
          } else if (
            val?.name
              ?.toString()
              .toLowerCase()
              .includes(inputData?.toLowerCase())
          ) {
            return val;
          }
          return false;
        });

        if (filteredOptions.length === 0) {
          setFilterOption([{ name: notOptionsValue }]);
        } else {
          setFilterOption(filteredOptions);
        }
      } else {
        setFilterOption(options);
      }
    },
    [inputData],
  );

  const handleSelect = (option, index = 0) => {
    if (ga4Data) {
      analyticsWrapper('ga4', {
        ...ga4Data,
        type: `${createSlug(option.name)}_click`,
      });
    }
    if (!sort) {
      onSelect(option, index);
    }
    // Immediately reflect the chosen option in the input to avoid temporary blank state
    if (searchOperation) {
      setInputData(option?.name || '');
      setIsCleared(false);
    }
    setIsOpen(false);
  };

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  // Auto-scroll the list to bring the selected option into view when opening
  useEffect(
    () => {
      if (!isOpen) return;
      const container = optionListRef.current;
      if (!container) return;

      const activeEl = container.querySelector(`li.${s.active}`) || null;
      if (activeEl) {
        const padding = 4; // small visual padding
        const itemTop = activeEl.offsetTop;
        const itemBottom = itemTop;
        const viewTop = container.scrollTop;
        const viewBottom = viewTop + container.clientHeight;

        if (itemTop < viewTop) {
          container.scrollTop = Math.max(itemTop - padding, 0);
        } else if (itemBottom > viewBottom) {
          container.scrollTop = itemBottom - container.clientHeight + padding;
        }
      }
    },
    [isOpen],
  );

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);
  const handleChangeInput = e => {
    if (!isCleared) {
      setInputData('');
      setInputData(e.target.value);
      setIsCleared(true);
    } else {
      setInputData(e.target.value);
    }
  };
  const handleBlur = event => {
    const nextElement = event.relatedTarget;
    if (optionListRef.current && optionListRef.current.contains(nextElement)) {
      // Do nothing if focus is within the dropdown
    } else {
      setInputData(selectedOption?.name || '');
      setIsCleared(false);
    }
  };
  let className = `${s.sortWrap} sortWrap ${s.filterWrap}`;

  if (typeTwoStyle) {
    className += ` ${s.typeTwo}`;
  }

  if (isOpen) {
    className += ` ${s.show} show`;
  }

  if (!sort && options && Array.isArray(options) && options.length === 1) {
    if (!Url && !fromRHS) {
      className += ` ${s.gray}`;
    }
  }

  if (selected) {
    className += ` ${s.selected}`;
  }

  if (active) {
    className += ` ${s.active}`;
  }

  return (
    <div
      className={className}
      onClick={
        (options && Array.isArray(options) && options.length > 1) ||
        handleToggleIcon
          ? handleToggle
          : null
      }
      ref={dropdownRef}
    >
      {label && label !== '' && label !== undefined && (inputData || isOpen) ? (
        <span className={s.label}>{label}</span>
      ) : null}
      <div
        className={`${s.sortContent} ${inputData || isOpen ? s.hasValue : ''}`}
      >
        {sort && (
          <>
            <i className={s.sortIocn} onClick={onSelect} />
            {!isWapView && <>Sort By : </>}
          </>
        )}
        {searchOperation && (
          <input
            className={s.search_input}
            id="searchOperation"
            type="text"
            ref={inputRef}
            value={inputData}
            placeholder={!inputData && !isOpen ? label : ''}
            onFocus={handleFocus}
            onBlur={handleBlur}
            onChange={handleChangeInput}
            autoComplete={autocomplete ? 'off' : ''}
          />
        )}
        {!searchOperation && (
          <span>
            <span>
              {(() => {
                if (!selectedOption?.name && !isOpen) {
                  return label;
                }
                if (placeHolder) {
                  return `${placeHolder}: `;
                }
                return '';
              })()}
            </span>{' '}
            <span
              className={
                selectedOption?.name &&
                typeof selectedOption.name === 'string' &&
                selectedOption?.name?.toLowerCase() === 'poll of polls'
                  ? s.strongText
                  : ''
              }
            >
              {selectedOption?.name || ''}
            </span>
          </span>
        )}
        {!sort && handleToggleIcon && <i className={s.downArrowIcon} />}
        {!sort &&
          !handleToggleIcon &&
          (options && Array.isArray(options) && options.length > 1) && (
            <i className={s.downArrowIcon} />
          )}
      </div>
      {!sort &&
        filterOption &&
        Array.isArray(filterOption) &&
        filterOption.length > 0 && (
          <ul className={`${s.sortList} sortList`} ref={optionListRef}>
            {filterOption &&
              Array.isArray(filterOption) &&
              filterOption.length &&
              filterOption.map((item, index) => (
                <li
                  key={index}
                  // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
                  tabIndex={0}
                  onClick={() => handleSelect(item, selectIndex)}
                  className={`${
                    item.name &&
                    typeof item.name === 'string' &&
                    item?.name?.toLowerCase().replace(/\s+/g, '-') ===
                      selectedOption?.name?.toLowerCase()
                      ? s.active
                      : ''
                  } ${
                    item.name &&
                    typeof item.name === 'string' &&
                    item?.name?.toLowerCase() === 'poll of polls'
                      ? s.strongText
                      : ''
                  }`}
                >
                  {item.name}
                </li>
              ))}
          </ul>
        )}
    </div>
  );
};

SelectDropdown.propTypes = {
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  onSelect: PropTypes.func.isRequired,
  selectedOption: PropTypes.string.isRequired,
};

export default SelectDropdown;
